import React from 'react';
import Box from '@material-ui/core/Box';

import HorizontalImageList from 'components/images/HorizontalImageList';
import { isBlank } from 'utils/helpers-ts';
import { resize512Image, removeSizes, resizeImage, isImageUrl } from 'utils/images-ts';
import ViewImageDialog from 'components/images/ViewImageDialog';
import { Divider } from '@material-ui/core';

interface IProps {
  imageOnly?: boolean;
  urls?: string[];
}

// Read-only image strip for the admin product preview. Same gallery component
// ShowProduct uses, so the preview renders images consistently.
const ReadOnlyImageGallery = ({ imageOnly, urls }: IProps) => {
  const [previewIndex, setPreviewIndex] = React.useState<number | undefined>(undefined);

  if (!urls?.length) return null;

  const validUrls = urls.filter(x => !isBlank(x));
  const imageUrls =  validUrls.filter(url => isImageUrl(url));
  const documentUrls = validUrls.filter(url => !isImageUrl(url));
  const previewImageUrls = imageUrls.map(url => resizeImage(url, 2000, 2000, 'auto', true, true));

  const showImageHeader = !imageOnly && !!imageUrls.length;
  const showDocumentHeader = !imageOnly && !!documentUrls.length;

  return (
    <Box>
      {showImageHeader && (
        <>
          <Divider style={{ marginTop: 24 }} />
          <h3>Bilder</h3>
        </>
      )}
      <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: showImageHeader ? 0 : 24 }}>
        <HorizontalImageList
          wrap
          imageUrls={imageUrls}
          height={256}
          imageResize={resize512Image}
          onClickImage={(index) => setPreviewIndex(index)}
        />
        {previewIndex !== undefined && (
          <ViewImageDialog
            srcs={previewImageUrls}
            initialIndex={previewIndex}
            onClose={() => setPreviewIndex(undefined)}
          />
        )}
      </Box>

      {showDocumentHeader && (
        <>
          <Divider style={{ marginTop: 16 }} />
          <h3>Dokument</h3>
        </>
      )}
      <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
        <HorizontalImageList
          wrap
          imageUrls={documentUrls}
          height={256}
          imageResize={resize512Image}
          onClickDocument={(src) => window.open(removeSizes(src), '_blank')}
        />
      </Box>
    </Box>
  );
};

export default ReadOnlyImageGallery;
